import { IsEnum, IsNotEmpty, IsNumber, IsString, IsUrl } from 'class-validator';
import { BaseDto } from '../../@base';
import { IsMongoIdObject } from '../../decorators/is-mongo-object-id.decorator';
import { FileId, UserId } from '../../types';
import { FilePurpose } from './file-purpose.enum';

export class FileDto extends BaseDto<FileId> {
  @IsString()
  @IsNotEmpty()
  filename!: string;

  @IsString()
  @IsNotEmpty()
  mimeType!: string;

  @IsNumber()
  @IsNotEmpty()
  size!: number;

  @IsUrl()
  @IsNotEmpty()
  url!: string;

  @IsMongoIdObject()
  @IsNotEmpty()
  uploadedBy!: UserId;

  @IsEnum(FilePurpose)
  @IsNotEmpty()
  purpose!: FilePurpose;
}
